import React, { Component } from 'react';
import { translate } from 'react-i18next';

const GENERALES = {
  encuesta_id: null,
  categoria_id: null,
  pregunta_id: null,
  obligatoria: "No"

};


class EncuestaGeneral extends Component {

  renderOpcionesTesting = (opciones, index) => {
    const { t } = this.props;
    if (opciones) {
      return (
        <div className="" key={index}>
          {opciones.opcion}
        </div>
      );
    } else {
      return (<div></div>);
    }
  }

  renderPregunta = (pregunta, index) => {
    GENERALES.pregunta_id = pregunta.id;
    if (pregunta.obligatoria == "Si") {
      GENERALES.obligatoria = "Si";
    } else {
      GENERALES.obligatoria = "No";
    }
    const { t } = this.props;
    switch (pregunta.tipo_pregunta) { /* Tipos de preguntas */
      default:
      case "1": // 1 - Opcion Multiple
        return this.renderPreguntaTipo1(pregunta, index);
        break;
      case "2": // 2 - Abierta    
        return this.renderPreguntaTipo2(pregunta, index);
        break;
      case "3": // 3 - Menú Desplegable
        return this.renderPreguntaTipo3(pregunta, index);
        break;
      case "4": // 4 - Ranking (no esta en produccion)
        break;
      case "5": // 5 - Cuadros de verificación
        return this.renderPreguntaTipo5(pregunta, index);
        break;
      case "6": // 6 - Esclusión de Preguntas (no esta en produccion)
        break;
      case "7": // 7 - Net Promoter Score
        return this.renderPreguntaTipo7(pregunta, index);
        break;
      case "8": // 7 - Escala
        return this.renderPreguntaTipo8(pregunta, index);
        break;
    }
  }

  renderPreguntaTipo1 = (pregunta, index) => { // 1 - Opcion Multiple  
    let encuesta = this.props.encuesta;
    return (

      <div key={index} className="pregunta-container" style={{ color: '#' + encuesta.color_letra, fontSize: encuesta.font_size + 'px' }}>
        <div >
          {pregunta.nombre}
        </div>
        <div className="pregunta-container-answer" style={{ paddingTop: '5px' }}>
          {pregunta.opciones.map((opciones, index) => this.renderOpcionesTipo1(opciones, index))}
        </div>
      </div>
    );
  }

  renderOpcionesTipo1 = (opciones, index) => {
    const { t } = this.props;
    if (GENERALES.obligatoria == "Si") {
      return (
        <div className="survey-label" key={index}>
          <label className="radio-button-container">
            <input required name={GENERALES.pregunta_id} id={GENERALES.pregunta_id} type="radio" className="" value={opciones.id} /> {opciones.opcion}
            <span className="checkmark"></span>
          </label>
        </div>
      );
    } else {
      return (
        <div className="survey-label">
          <label className="radio-button-container">
            <input name={GENERALES.pregunta_id} id={GENERALES.pregunta_id} type="radio" className="" value={opciones.id} /> {opciones.opcion}
            <span className="checkmark"></span>
          </label>
        </div>
      );
    }

  }

  renderPreguntaTipo2 = (pregunta, index) => { // 2 - Abierta 
    let encuesta = this.props.encuesta;
    if (GENERALES.obligatoria == "Si") {
      return (
        <div className="pregunta-container" key={index} style={{ color: '#' + encuesta.color_letra, fontSize: encuesta.font_size + 'px' }}>
          <div >
            {pregunta.nombre}
          </div>
          <div className="pregunta-container-answer">
            <input required type="text" className="form-control" id={GENERALES.pregunta_id} name={GENERALES.pregunta_id} />
          </div>
        </div>
      );
    } else {
      return (
        <div className="pregunta-container">
          <div >
            {pregunta.nombre}
          </div>
          <div className="pregunta-container-answer">
            <input type="text" className="form-control" id={GENERALES.pregunta_id} name={GENERALES.pregunta_id} />
          </div>
        </div>
      );
    }

  }

  renderPreguntaTipo3 = (pregunta, index) => { // 1 - Opcion Multiple
    let encuesta = this.props.encuesta;
    if (GENERALES.obligatoria == "Si") {
      return (
        <div className="pregunta-container" key={index} style={{ color: '#' + encuesta.color_letra, fontSize: encuesta.font_size + 'px' }}>
          <div >
            {pregunta.nombre}
          </div>
          <div className="pregunta-container-answer">
            <select required name={GENERALES.pregunta_id} id={GENERALES.pregunta_id}>
              <option value="">Seleccione una opcion...</option>
              {pregunta.opciones.map((opciones, index) => this.renderOpcionesTipo3(opciones, index))}
            </select>
          </div>
        </div>
      );
    } else {
      return (
        <div className="pregunta-container" style={{ color: '#' + encuesta.color_letra, fontSize: encuesta.font_size + 'px' }}>
          <div className="pregunta-container-answer">
            {pregunta.nombre}
          </div>
          <div >
            <select name={GENERALES.pregunta_id} id={GENERALES.pregunta_id}>
              <option value="0">Seleccione una opcion...</option>
              {pregunta.opciones.map((opciones, index) => this.renderOpcionesTipo3(opciones, index))}
            </select>
          </div>
        </div>
      );
    }

  }

  renderOpcionesTipo3 = (opciones, index) => {
    const { t } = this.props;
    return (
      <option key={index} value={opciones.id}>{opciones.opcion}</option>
    );
  }

  renderPreguntaTipo5 = (pregunta, index) => { // 1 - Opcion Multiple
    let encuesta = this.props.encuesta;
    return (
      <div  key={index} className="pregunta-container" style={{ color: '#' + encuesta.color_letra, fontSize: encuesta.font_size + 'px' }}>
        <div >
          {pregunta.nombre}
        </div>
        <div className="pregunta-container-answer">
          {pregunta.opciones.map((opciones, index) => this.renderOpcionesTipo5(opciones, index))}
        </div>
      </div>
    );
  }

  renderOpcionesTipo5 = (opciones, index) => {
    const { t } = this.props;
    return (
      <div className="survey-label" key={index}>
        <input className="palomita" type="checkbox" id={opciones.id} name={opciones.id} value={opciones.id} />
        <label for={opciones.id}>{opciones.opcion}</label>
      </div>
    );
    /* ----------------------> DUDA DE EL NOMBRE PARA LOS CHECKBOX <---------------------- */
  }

  renderPreguntaTipo7 = (pregunta, index) => { // 7 - Net Promoter Score 
    let encuesta = this.props.encuesta;
    return (
      <div className="pregunta-container" key={index} style={{ color: '#' + encuesta.color_letra, fontSize: encuesta.font_size + 'px' }}>
        <div >
          {pregunta.nombre}
        </div>
        <div className="pregunta-container-answer">
          <input name={GENERALES.pregunta_id} id={GENERALES.pregunta_id} type="range" steep="1" min="1" max="10" />
        </div>
      </div>
    );
  }

  renderPreguntaTipo8 = (pregunta, index) => { // 8 - ESCALA 
    let encuesta = this.props.encuesta;
    return (
      <div className="pregunta-container"  key={index}  style={{ color: '#' + encuesta.color_letra, fontSize: encuesta.font_size + 'px' }}>
        <div >
          {pregunta.nombre}
        </div>
        <div className="rb-box pregunta-container-answer">
          <div id="rb-1" className="rb" >

            <div id={`boton0_${pregunta.id}`} className="rb-tab" value="0" onClick={this.props.activarBoton}>
              <div className="rb-spot" id="opcion0" name={pregunta.id}>
                <span id="opcion0" name={pregunta.id} className="rb-txt">0</span>
              </div>
            </div>

            <div id={`boton1_${pregunta.id}`} className="rb-tab" value="1" onClick={this.props.activarBoton}>
              <div className="rb-spot" id="opcion1" name={pregunta.id}>
                <span id="opcion1" name={pregunta.id} className="rb-txt">1</span>
              </div>
            </div>

            <div id={`boton2_${pregunta.id}`} className="rb-tab" value="2" onClick={this.props.activarBoton}>
              <div className="rb-spot" id="opcion2" name={pregunta.id}>
                <span id="opcion2" name={pregunta.id} className="rb-txt">2</span>
              </div>
            </div>
            <div id={`boton3_${pregunta.id}`} className="rb-tab" value="3" onClick={this.props.activarBoton}>
              <div className="rb-spot" id="opcion3" name={pregunta.id}>
                <span id="opcion3" name={pregunta.id} className="rb-txt">3</span>
              </div>
            </div>
            <div id={`boton4_${pregunta.id}`} className="rb-tab" value="4" onClick={this.props.activarBoton}>
              <div className="rb-spot" id="opcion4" name={pregunta.id}>
                <span id="opcion4" name={pregunta.id} className="rb-txt">4</span>
              </div>
            </div>
            <div id={`boton5_${pregunta.id}`} className="rb-tab" value="5" onClick={this.props.activarBoton}>
              <div className="rb-spot" id="opcion5" name={pregunta.id}>
                <span id="opcion5" name={pregunta.id} className="rb-txt">5</span>
              </div>
            </div>
            <div id={`boton6_${pregunta.id}`} className="rb-tab" value="6" onClick={this.props.activarBoton}>
              <div className="rb-spot" id="opcion6" name={pregunta.id}>
                <span id="opcion6" name={pregunta.id} className="rb-txt">6</span>
              </div>
            </div>
            <div id={`boton7_${pregunta.id}`} className="rb-tab" value="7" onClick={this.props.activarBoton}>
              <div className="rb-spot" id="opcion7" name={pregunta.id}>
                <span id="opcion7" name={pregunta.id} className="rb-txt">7</span>
              </div>
            </div>
            <div id={`boton8_${pregunta.id}`} className="rb-tab" value="8" onClick={this.props.activarBoton}>
              <div className="rb-spot" id="opcion8" name={pregunta.id}>
                <span id="opcion8" name={pregunta.id} className="rb-txt">8</span>
              </div>
            </div>
            <div id={`boton9_${pregunta.id}`} className="rb-tab" value="9" onClick={this.props.activarBoton}>
              <div className="rb-spot" id="opcion9" name={pregunta.id}>
                <span id="opcion9" name={pregunta.id} className="rb-txt">9</span>
              </div>
            </div>
            <div id={`boton10_${pregunta.id}`} className="rb-tab" value="10" onClick={this.props.activarBoton}>
              <div className="rb-spot" id="opcion10" name={pregunta.id}>
                <span id="opcion10" name={pregunta.id} className="rb-txt">10</span>
              </div>
            </div>

          </div>
        </div>
        <input type="hidden" className="form-control" id={pregunta.id} name={pregunta.id} />
      </div>
    );
  }

  renderCategorias = (categoria, index) => {
    const { t } = this.props;
    GENERALES.categoria_id = categoria.id;
    return (
      <div key={index}>
        <div  >
          {categoria.pregunta.map((pregunta, index) => this.renderPregunta(pregunta, index))}
        </div>

      </div>
    );
  }

  render() {
    let encuesta = this.props.encuesta;
    const { t } = this.props;

    if (encuesta) {

      //console.log("a donde lo manda-------->",this.props.handleQuestionsForm);
      GENERALES.encuesta_id = encuesta.id;
      var titulo = encuesta.nombre;
      var titulo_mayusculas = titulo.toUpperCase();

      //console.log("Encuesta General=====>",encuesta );
      return (
        <div id="preguntasSurvey" className="survey-page-body-encuestras" style={{ color: "#" + encuesta.color_letra }}>
          <div className="survey-titulo" style={{ color: '#' + encuesta.color_letra, fontSize: encuesta.font_size + 'px' }} >
            {titulo_mayusculas}
          </div>

          <form method="post" onSubmit={this.props.handleQuestionsForm}>
            <fieldset>
              {encuesta.categoria.map((categoria, index) => 
              this.renderCategorias(categoria, index))
              }
              <div className="form-group text-center">
                <button
                  className="btn btn-primary"
                  type="submit">
                  {t('guest.getsurveydata.btn_continue')}
                </button>
              </div>
            </fieldset>
          </form>
        </div>

      );

    } else {
      return (
        <div id="graciasSurvey" className="survey-page-body" >
          <div className="alert alert-info" >
            La encuesta no se encuetra activa por el momento
          </div>
        </div>
      );
    }

  }

}

export default translate('common')(EncuestaGeneral);



// WEBPACK FOOTER //
// ./src/guest/GetSurveyData/EncuestaGeneral.js